import { useChatNotificationsCounterEvents } from '@/modules/unread-counts/presentation/hooks/useChatNotificationCounterEvents'
import { useTicketChatUserNotificationCounterEvents } from '@/modules/unread-counts/presentation/hooks/useTicketChatUserNotificationCounterEvents'
import { useUserNotificationsCounterEvents } from '@/modules/unread-counts/presentation/hooks/useUserNotificationsCounterEvents'
import { useFeatureFlagManager } from '@/ui/hooks/useFeatureFlagManager'
import { useMarkedStartupHooks } from '@/ui/hooks/useMarkedStartupHooks'
import { usePresence } from '@/ui/hooks/usePresence'
import useProfileStartup from '@/ui/hooks/useProfileStartup'
import { useUserPermission } from '@/ui/hooks/useUserPermission'

export default function InitialLoad({
  children
}: {
  children: React.ReactNode
}) {
  useUserPermission()
  useFeatureFlagManager()
  useProfileStartup()
  useMarkedStartupHooks()
  usePresence()
  useTicketChatUserNotificationCounterEvents()
  useChatNotificationsCounterEvents()
  useUserNotificationsCounterEvents()

  return children
}
